import BagInfoBox from '@moncler/components/bag/BagInfoBox';
import ExpressPaymentsMinicart from '@components/bag/ExpressPaymentsMinicart';
import LoginOrRegisterColumn from '@components/login/LoginOrRegisterColumn';
import { MinicartActionTypes } from '@state/features/common.types';
import Button from '@ui/button/Button';
import analytics from '@utils/analytics';
import classNames from 'classnames';
import FocusTrap from 'focus-trap-react';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import ShippingDisclaimer from '../product/ShippingDisclaimer';
import useInnerWidth from '@utils/useInnerWidth';
import MiniBagItem from './MiniBagItem';
import useBreakpoint from '@common/utils/useBreakpoint';
import { addURLParameter } from '@common/utils/urlutils';
import paymentutils from '@common/utils/paymentutils';
export const getFocusableEl = (parent, which) => {
    const focusableEls = Array.from(parent.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'));
    const actualFocusableEls = focusableEls.filter((el) => window.getComputedStyle(el).display != 'none');
    if (which == 'first') {
        return actualFocusableEls[0];
    }
    else {
        return actualFocusableEls[actualFocusableEls.length - 1];
    }
};
const MiniBagModal = (props) => {
    var _a, _b, _c, _d;
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [modalExpressPaymentsOpen, setModalExpressPaymentsOpen] = useState(false);
    const [modalLoginMinicart, setModalLoginMinicart] = useState(false);
    const [loaded, setLoaded] = useState(0);
    const buttonsRef = useRef();
    const expressCtaRef = useRef();
    const wrapper = useRef(null);
    const [buttonsHeight, setButtonsHeight] = useState();
    const [wrapperHeight, setWrapperHeight] = useState();
    const currentBreakpoint = useBreakpoint();
    const currentWidth = useInnerWidth();
    const [forceReload, setForceReload] = useState(false);
    const { minicart } = useSelector((state) => state.minicart);
    const isOpen = useMemo(() => {
        if (loaded >= 3) {
            if (modalExpressPaymentsOpen) {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    }, [modalExpressPaymentsOpen, loaded]);
    useEffect(() => {
        const body = document.querySelector('body');
        let footer = document.querySelector('.footer');
        if (window.innerWidth >= window.mqObj.md && footer) {
            body.style.setProperty('--footer-height', `${footer.clientHeight}px`);
        }
    });
    useEffect(() => {
        if (modalExpressPaymentsOpen) {
            dispatch({ type: MinicartActionTypes.HOVERING_MINICART });
        }
    }, [modalExpressPaymentsOpen]);
    const updateExpressButtonsHeight = () => {
        var _a;
        if (isOpen) {
            setTimeout(() => {
                var _a;
                let express = (_a = buttonsRef.current) === null || _a === void 0 ? void 0 : _a.querySelector('.minibag__expresspayment');
                setButtonsHeight(express === null || express === void 0 ? void 0 : express.offsetHeight);
                setWrapperHeight((express === null || express === void 0 ? void 0 : express.offsetHeight) * 2 || 216);
            }, 200);
        }
        else {
            const wrapper = (_a = buttonsRef.current) === null || _a === void 0 ? void 0 : _a.querySelector('.minibag__buttons__wrapper');
            setButtonsHeight(wrapper === null || wrapper === void 0 ? void 0 : wrapper.offsetHeight);
            setWrapperHeight((wrapper === null || wrapper === void 0 ? void 0 : wrapper.offsetHeight) * 2 || 216);
        }
    };
    useEffect(() => {
        updateExpressButtonsHeight();
    }, [isOpen]);
    const updateBag = () => {
        dispatch({ type: MinicartActionTypes.UPDATE_MINICART });
    };
    useEffect(() => {
        if (!modalExpressPaymentsOpen) {
            updateBag();
        }
    }, [modalExpressPaymentsOpen]);
    // useEffect(() => {
    // if (justAdded && lastAdded) {
    // console.info('last element added: ', lastAdded);
    //     const bagItem = document.querySelector(`[data-bagid='${lastAdded}']`) as HTMLElement;
    //     setTimeout(() => {
    //       bagItem?.focus();
    //     }, 550);
    //   }
    // }, [justAdded, lastAdded]);
    if (!minicart) {
        return React.createElement(React.Fragment, null);
    }
    if (minicart.numItems === 0) {
        return (React.createElement(React.Fragment, null,
            React.createElement("button", { className: "d-sm-none icon--close", "aria-label": t('button.close'), onClick: () => props.onClose() }),
            React.createElement("h2", { className: "minibag__title--empty" }, t('bag.emptymessage'))));
    }
    const buttonLogin = () => {
        if (window.loggedin) {
            location.href = window.loginUrl;
            return;
        }
        props.isDesktop ? setModalLoginMinicart(true) : props.onLoginClick();
        analytics.expressCheckoutLoginRegister('mini bag');
    };
    return (React.createElement(React.Fragment, null,
        modalLoginMinicart && (
        // TODO remove this component once all the variants have been handled
        // <ExpressModalLogin
        //   active={modalLoginMinicart}
        //   isMBM={minicart.containsMbm}
        //   privacypolicy={props.privacypolicy}
        //   forgotpasswordform={props.forgotpasswordform}
        //   onClose={() => {
        //     setModalLoginMinicart(false);
        //   }}
        //   onCloseAll={() => {
        //     setModalLoginMinicart(false);
        //     props.onClose();
        //   }}
        // />
        React.createElement(FocusTrap, { focusTrapOptions: {
                onDeactivate: () => setModalLoginMinicart(false),
                fallbackFocus: () => wrapper.current,
                initialFocus: () => wrapper.current,
                clickOutsideDeactivates: true,
            }, active: modalLoginMinicart },
            React.createElement("div", { ref: wrapper, className: "minibag-login", "aria-modal": modalLoginMinicart, role: "dialog", tabIndex: -1 },
                React.createElement(LoginOrRegisterColumn, Object.assign({}, props, { onBack: () => setModalLoginMinicart(false), closeModal: () => {
                        setModalLoginMinicart(false);
                        props.onClose();
                        if (forceReload) {
                            window.location.href = addURLParameter(window.location.href, 'openMiniCart', 'true');
                        }
                    }, from: 'mini bag', setForceReload: setForceReload, inModal: true, linkreload: window.location.href.includes('query=') || window.location.href.includes('pli=')
                        ? `${window.location.href}&openMiniCart=true`
                        : `${window.location.href}?openMiniCart=true` }))))),
        React.createElement("div", { className: "container-minibag-up", style: { height: wrapperHeight && currentWidth > window.mqObj.sm ? `calc(100% - ${wrapperHeight}px` : 'auto' } },
            React.createElement("div", { className: "container-title bold" },
                React.createElement("h2", { className: "minibag__title" },
                    `${t('bag.summary')}`,
                    minicart.numItems && React.createElement("span", null,
                        " (",
                        minicart.numItems,
                        ")")),
                React.createElement("button", { type: "button", "aria-label": t('button.close'), className: "modal__close", onClick: (e) => {
                        e.stopPropagation();
                        props.onClose();
                    } })),
            props.showLoginBox && !window.loggedin && React.createElement(BagInfoBox, { text: t(minicart.containsMbm ? 'checkout.mbmlogin' : 'checkout.login.subtitle'), buttonAction: buttonLogin }),
            React.createElement("ul", { className: "d-none d-sm-block minibag__list" }, [...minicart.items].map((i) => (React.createElement(MiniBagItem, { faqurl: props.faqurl, updateWishlist: props === null || props === void 0 ? void 0 : props.updateWishlist, key: i.UUID, onRemove: () => updateBag(), showLoginModal: props.onLoginClick, item: i })))),
            React.createElement("ul", { className: "d-block d-sm-none minibag__mobile" },
                React.createElement(MiniBagItem, { faqurl: props.faqurl, updateWishlist: props === null || props === void 0 ? void 0 : props.updateWishlist, key: minicart.items[0].UUID, onRemove: () => updateBag(), item: minicart.items[0], showLoginModal: props.onLoginClick })),
            minicart.numItems > 1 && minicart.items.length > 1 && (React.createElement("a", { className: "d-block d-sm-none minibag__mobile-label", href: props.carturl },
                React.createElement("p", null, `+${minicart.numItems - 1} ${t(minicart.numItems > 2 ? 'bag.moreitems' : 'bag.moreitem')} `)))),
        React.createElement("div", { className: "container-minibag-down" },
            React.createElement("div", { className: "minibag__total bold" },
                React.createElement("h3", null, t('bag.esttotal')),
                React.createElement("p", null, (_b = (_a = minicart.totals) === null || _a === void 0 ? void 0 : _a.subTotal) !== null && _b !== void 0 ? _b : 0.0)),
            window.isClothing && (React.createElement("div", { className: "minibag__available primary-xs" },
                React.createElement("h3", null, t('bag.available')),
                React.createElement("p", null, (_c = minicart.totals) === null || _c === void 0 ? void 0 : _c.availablePlafond))),
            window.country === 'RU' && (React.createElement("div", { className: "minibag__disclaimer" },
                React.createElement("p", { className: "tax-disclaimer", dangerouslySetInnerHTML: { __html: t('bag.taxdisclaimer') } }))),
            React.createElement(ShippingDisclaimer, { incontext: "bag" }),
            minicart.containsMbm && React.createElement("p", { className: "text-disclaimer", dangerouslySetInnerHTML: { __html: t('mbm.bagdisclaimer', { 0: props === null || props === void 0 ? void 0 : props.mbmreturnpolicy }) } }),
            React.createElement("div", { ref: buttonsRef, className: "minibag__buttons", style: { height: buttonsHeight ? `${buttonsHeight}px` : 'auto' } },
                React.createElement("div", { className: classNames('minibag__buttons__wrapper', { hide: isOpen }) },
                    React.createElement("button", { className: "button button--primary", onClick: () => {
                            if (minicart.containsMbm && !window.loggedin) {
                                props === null || props === void 0 ? void 0 : props.onLoginClick();
                            }
                            else {
                                analytics.miniBagCheckout();
                                // TODO da verificare per tema accessibilità
                                location.href = props.checkouturl;
                            }
                        } },
                        React.createElement("span", null, t('label.checkout'))),
                    !window.isClothing && (React.createElement(React.Fragment, null, paymentutils.areExpressPaymentsAvailableForSession() && !minicart.noexpresscheckout && !minicart.items.find((el) => { var _a; return !el.available && !((_a = el === null || el === void 0 ? void 0 : el.availability) === null || _a === void 0 ? void 0 : _a.preorder); }) && (React.createElement(Button, { cls: ['button--secondary'], type: 'button', disabled: ((_d = minicart === null || minicart === void 0 ? void 0 : minicart.items) === null || _d === void 0 ? void 0 : _d.find((el) => { var _a; return !el.available && !((_a = el === null || el === void 0 ? void 0 : el.availability) === null || _a === void 0 ? void 0 : _a.preorder); })) != undefined || minicart.checkoutDisabled, onClick: () => {
                            if (minicart.containsMbm && !window.loggedin) {
                                props === null || props === void 0 ? void 0 : props.onLoginClick();
                            }
                            else {
                                analytics.checkoutTypeChose('mini bag', 'express checkout');
                                setModalExpressPaymentsOpen(true);
                            }
                        }, isLoading: modalExpressPaymentsOpen && loaded != 3, ariaExpanded: isOpen, reference: expressCtaRef, "aria-controls": "expressCheckoutMinicart" },
                        React.createElement("span", null, t('checkout.expresscheckout')))))),
                    React.createElement("a", { className: "button btn-view-bag", href: props.carturl, onClick: () => {
                            analytics.miniBagViewBag();
                        } },
                        React.createElement("span", null, t('bag.viewbag')))),
                React.createElement(ExpressPaymentsMinicart, Object.assign({}, props, { modalExpressPaymentsOpen: modalExpressPaymentsOpen, onClose: () => {
                        setModalExpressPaymentsOpen(false);
                        setTimeout(() => {
                            var _a;
                            (_a = expressCtaRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                        }, 250);
                    }, isOpen: isOpen, onLoad: () => setLoaded((value) => ++value), onUpdate: updateExpressButtonsHeight }))))));
};
export default MiniBagModal;
